import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { formatTime } from '@/core';

/** app store — 面包屑、数据刷新时间、动效降级（?static）、告警未读角标 */
export const useAppStore = defineStore('app', () => {
  const crumb = ref('中控看板');
  const refreshedAt = ref<Date>(new Date());
  const alertUnread = ref(6);
  const sidebarCollapsed = ref(false);
  /** 跨组件 KPI 刷新信号：录入页提交成功后 +1，外壳监听后重取 KPI */
  const kpiRefreshTrigger = ref(0);

  function bumpKpi(): void {
    kpiRefreshTrigger.value++;
  }

  /** ?static 关闭动效：用于截图与低性能设备（原型同款降级开关） */
  const staticMode = computed(() => {
    const hash = window.location.hash || '';
    const search = window.location.search || '';
    return /[?&]static\b/.test(hash) || /[?&]static\b/.test(search);
  });

  function setCrumb(value: string): void {
    crumb.value = value;
  }

  function markRefreshed(at = new Date()): void {
    refreshedAt.value = at;
  }

  const refreshedText = computed(() => `数据更新于 ${formatTime(refreshedAt.value)}`);

  function toggleSidebar(): void {
    sidebarCollapsed.value = !sidebarCollapsed.value;
  }

  return { crumb, refreshedAt, refreshedText, alertUnread, sidebarCollapsed, staticMode, kpiRefreshTrigger, bumpKpi, setCrumb, markRefreshed, toggleSidebar };
});
